import { render, staticRenderFns } from "./ku-article-hot.vue?vue&type=template&id=7c2c57ed"
import script from "./ku-article-hot.vue?vue&type=script&lang=js"
export * from "./ku-article-hot.vue?vue&type=script&lang=js"
import style0 from "./ku-article-hot.vue?vue&type=style&index=0&id=7c2c57ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports